<div class="container">
    <div class="row justify-content-center align-items-center" style="min-height: 77vh;">
        <div class="col-md-4">

                <div class="card-body">
                    <div class="mi-caja mt-3">
                        <form [formGroup]="loginForm">
                            <br>
                            <br>
                            <br>
                            <h3 class="govco-title-sign-form headline-l-govco "
                                style="text-align: center; font-size: 30px">
                                Inicio de sesión
                            </h3>
                            <div class="row mt-3">
                                <div class="d-flex mt-2"
                                    style="display: flex; align-items: center; justify-content: center;">

                                    <button type="submit" (click)="submitLoginFormB2C()"
                                        class="btn-govco fill-btn-govco">Iniciar
                                    </button>

                                </div>
                            </div>
                        </form>
                        <br>
                        <br>
                    </div>
                </div>

        </div>
    </div>

</div>
<div class="loading loading--show">
  <div class="spin"></div>
</div>
